import ProjectTemplate from '../../components/common/ProjectTemplate';
import StructureListActionButtons from '../../components/conveyor-structure/StructureListActionButtons';
import StructureListContainer from '../../components/conveyor-structure/StructureListContainer';

const StructureListPage = () => {
    return (
        <ProjectTemplate>
            <StructureListContainer />
            <StructureListActionButtons />
        </ProjectTemplate>
    );
};

export default StructureListPage;
